export default __webpack_public_path__ + "static/media/adi-learning-hub-new.7326ba7e.svg";